import invariant from 'invariant';

import { compose, getIn, stringify } from 'utils/functional';

let config = null;
export const configValue = (
  ...path: Array<string>
): string | null | undefined => getIn(config, path);
export const requiredConfig = (...path: Array<string>): string => {
  const v = getIn(config, path);
  invariant(v, `Config value ${path.toString()} is required`);
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type 'string'.
  return v;
};
export const configString: (...args: Array<string>) => string = compose(
  stringify,
  requiredConfig
);
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfigOnce = (newConfig: Record<string, any>) => {
  if (!config) {
    config = newConfig;
  }
};
